import { render, staticRenderFns } from "./Restreaming.vue?vue&type=template&id=8025b1e8"
import script from "./Restreaming.vue?vue&type=script&lang=js"
export * from "./Restreaming.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports